<template>

  <div class="pb50">
    <el-form ref="form" size="small" :model="form" label-width="200px">
      <div class="common-form">设置</div>
       <el-form-item label="是否开启发布素材通道">
        <el-radio-group v-model="form.is_material_open">
          <el-radio :label="1">开启</el-radio>
          <el-radio :label="0">关闭</el-radio>
        </el-radio-group>
        <div class="lh18 mt10 gray9">
          <p>开启后，用户端可以发布</p>
        </div>
      </el-form-item>
      <el-form-item label="发布素材送积分 " prop="material_points" :rules="[{required: true,message: ' '}]">
        <el-input placeholder="请输入积分" type="number" min="0" v-model="form.material_points" class="max-w460">
          <template slot="append">积分</template>
        </el-input>
        <p>每次发布获得积分</p>
      </el-form-item>
      <el-form-item label="发布素材积分限制">
        <el-input placeholder="请输入内容" v-model="form.max_material_points" class="max-w460">
          <template slot="prepend">每天最多获得</template>
          <template slot="append">积分</template>
        </el-input>
        <div class="gray">为零或者 不设置 则不限制</div>
      </el-form-item>
      <el-form-item label="分享素材收益 " prop="material_profits" :rules="[{required: true,message: ' '}]">
        <el-input placeholder="请输入收益百分比" type="number" min="0" v-model="form.material_profits" class="max-w460">
          <template slot="append">%</template>
        </el-input>
        <div class="lh18 mt10 gray9">
          <p> 注：通过素材渠道下单，对应的发布者可以获得订单金额的 % 收益</p>
        </div>
      </el-form-item>
      <el-form-item label="分享素材积分 " prop="material_order_points" :rules="[{required: true,message: ' '}]">
        <el-input placeholder="请输入积分百分比" type="number" min="0" v-model="form.material_order_points" class="max-w460">
          <template slot="append">%</template>
        </el-input>
        <div class="lh18 mt10 gray9">
          <p> 注：通过素材渠道下单，对应的发布者可以获得订单金额的 % 积分奖励</p>
        </div>
      </el-form-item>
      <el-form-item label="敏感词" prop="sensitive_words">
        <el-input type="textarea" rows="10" v-model="form.sensitive_words" autocomplete="off" placeholder="请输入敏感词" class="max-w460"></el-input>
        <div class="">敏感词以英文逗号间隔，发布内容包含敏感词将不能发布</div>
      </el-form-item>
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button type="primary" size="small" @click="onSubmit" :loading="loading">提交</el-button>
      </div>

    </el-form>
  </div>
</template>
<script>
  import MaterialApi from '@/api/material.js';
  export default {
    data() {
      return {
        form: {
          is_material_open: 0,
          material_points:0,
          max_material_points:0,
          material_profits: 0,
          material_order_points: 0,
          sensitive_words:'',
        },
        loading: false,
      };
    },
    created() {
      /*获取数据*/
      this.getData();
    },
    methods: {
      /*获取数据*/
      getData() {
        let self = this;
        let Params = {};
        MaterialApi.getSetting(Params, true).then(res => {
          self.form = res.data.setting;
          if(res.data.setting.is_material_open){
             self.form.is_material_open = parseInt(res.data.setting.is_material_open);
          }
         
        }).catch(error => {

        });
      },

      /*保存*/
      onSubmit() {
        let self = this;
        let form = self.form;
        self.$refs.form.validate((valid) => {
          if (valid) {
            self.loading = true;
            MaterialApi.setSetting(form, true)
              .then(data => {
                self.loading = false;
                if (data.code == 1) {
                  self.$message({
                    message: '恭喜你，保存成功',
                    type: 'success'
                  });
                } else {
                  self.loading = false;
                }
              })
              .catch(error => {
                self.loading = false;
              });

          }
        });


      },
    }
  };
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/plus/material/setting/Setting.vue